export class CategoriasBS {
    idCategoriasBS: number;
    idProyecto: number;
    nombre: string;
    idUsuario: number;
}